// extracted by mini-css-extract-plugin
var _1 = "PresenceAvatarStack-module__avatar--k9LVC";
var _2 = "PresenceAvatarStack-module__container--ZuXG4";
export { _1 as "avatar", _2 as "container" }
